// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__14LJh","large":"styles_large__1Wo24"};